<h3>Confirm</h3>
<div style="padding-bottom: 10px;">{{confirmMessage}}</div>
<div style="display: flex;flex-direction: row; justify-content: flex-end;">
    <button mat-button fxLayoutAlign="end" style="margin-bottom: 5px;margin-right: 5px;" color="secondary" class="pl-button"
        (click)="dialogRef.close(false)">Cancel</button>
    <button mat-button fxLayoutAlign="end" style="margin-bottom: 5px;" color="primary" class="pl-button"
        (click)="dialogRef.close(true)">Confirm</button><br>
</div>